export default __webpack_public_path__ + "static/media/download_grey.591ce706.svg";